import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { AGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { STATUS_TO_TEXT_MAP } from "./utils";

interface Props {
  params: AGGridCellRenderParams;
}

export const StatusCellRenderer = ({ params }: Props) => {
  const {
    displayText,
    iconType = null,
    iconColor = Colors.Neutral900,
  } = STATUS_TO_TEXT_MAP(params.value.toString()) || {};
  return (
    <Flex alignItems="center" gap={4} css={{ height: "100%" }}>
      {iconType && <Icon type={iconType} color={iconColor} />}
      <Text data-testid="profile-name-label" css={{ color: iconColor }} marginBottom="xs">
        {displayText}
      </Text>
    </Flex>
  );
};
